import HTTP from './http-request-handler'

const forgotPasswordService = {
  sendVerificationLink: function (params) {
    return HTTP.post('/forgotPassword/validateEmail', { ...params })
      .then(response => {
        if (response.data.success === true) {
          return response.data
        } else {
          return response.data
        }
      }).catch(e => {
        return (e.response && e.response.data) ? e.response.data : e
      })
  },
  verifyEmail: function (params) {
    return HTTP.post('/forgotPassword/verifyEmail', { ...params })
      .then(response => {
        if (response.data.success === true) {
          return response.data
        } else {
          return response.data
        }
      }).catch(e => {
        return (e.response && e.response.data) ? e.response.data : e
      })
  },
  resetPassword: function (params) {
    return HTTP.post('/forgotPassword/resetPassword', { ...params })
      .then(response => {
        if (response.data.success === true) {
          return response.data
        } else {
          return response.data
        }
      }).catch(e => {
        return (e.response && e.response.data) ? e.response.data : e
      })
  },
  resendVerificationLink: function (params) {
    return HTTP.post('/forgotPassword/resendVerificationLink', { ...params })
      .then(response => {
        if (response.data.success === true) {
          return response.data
        } else {
          return response.data
        }
      }).catch(e => {
        return (e.response && e.response.data) ? e.response.data : e
      })
  }
}
export default forgotPasswordService
